import { render, staticRenderFns } from "./DialogProcess.vue?vue&type=template&id=36f6d5e6&"
import script from "./DialogProcess.vue?vue&type=script&lang=js&"
export * from "./DialogProcess.vue?vue&type=script&lang=js&"
import style0 from "./DialogProcess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports